module.exports = {
    fr: {
        meta: {
            title: "Blog de Davoyage : découvrez les dernières tendances en matière de transport privé",
            description: "Découvrez les dernières tendances en matière de transport privé sur le blog de Davoyage, votre partenaire de confiance pour vos déplacements professionnels ou personnels. Retrouvez des conseils, des astuces et des actualités sur notre blog pour voyager en toute sérénité.",    
        },
        og: {
            image: {
                url: "https://res.cloudinary.com/dgdbo8vri/dpr_auto,q_auto/v1791370742/transfert-lyon-val-d-isere-van-noir.webp",
                alt: "Mercedes Classe V Davoyage, chauffeur privé"
            }
        },
        eyebrow: "Carnets de route",
        head: "Escapades et transferts au départ de Lyon",
        lead: "Vignobles, stations de ski, aéroports\u00a0: itinéraires, temps de trajet et conseils de nos chauffeurs pour voyager sans prendre le volant.",
        photoBy: "Photo\u00a0:",
        photoOn: "sur",
        crumb: "Blog",
        all: "Tous",
        featured: "À la une",
        latest: "Derniers articles",
        related: "À lire ensuite",
        allArticles: "Tous les articles",
        readMore: "Lire l'article",
        readTime: "min de lecture",
        fromLyon: "depuis Lyon",
        author: "L'équipe Davoyage",
        facts: "En bref",
        toc: "Sommaire",
        quote: "Demander un devis",
        quoteShort: "Devis",
        call: "Appeler",
        bookEyebrow: "Réserver ce trajet",
        bookTitle: "Trajet avec chauffeur privé",
        bookPoints: ["Prise en charge à l'hôtel, à la gare ou à l'aéroport", "Votre chauffeur vous attend à chaque étape", "Vos bagages et achats restent dans le coffre"],
        ctaEyebrow: "Votre trajet",
        ctaTitle: "Une station, un vignoble, un vol à attraper\u00a0?",
        ctaText: "Dites-nous la date, le nombre de passagers et vos envies\u00a0: nous vous envoyons une proposition.",
        categories: {
            vignobles: "Vignobles",
            ski: "Stations de ski",
            aeroports: "Aéroports et gares",
            excursions: "Excursions",
            pratique: "Infos pratiques"
        }
    },
    en: {
        meta: {
            title: "Davoyage Blog - Stay up-to-date with the latest travel tips and trends",
            description: "Stay informed with Davoyage Blog, your source for travel tips, trends, and news. From insider knowledge to destination guides, we've got you covered.",    
        },
        og: {
            image: {
                url: "https://res.cloudinary.com/dgdbo8vri/dpr_auto,q_auto/v1791370742/transfert-lyon-val-d-isere-van-noir.webp",
                alt: "Mercedes Classe V Davoyage, chauffeur privé"
            }
        },
        eyebrow: "Travel notes",
        head: "Day trips and transfers from Lyon",
        lead: "Vineyards, ski resorts, airports: routes, travel times and tips from our drivers, so you can travel without taking the wheel.",
        photoBy: "Photo:",
        photoOn: "on",
        crumb: "Blog",
        all: "All",
        featured: "Featured",
        latest: "Latest articles",
        related: "Read next",
        allArticles: "All articles",
        readMore: "Read the article",
        readTime: "min read",
        fromLyon: "from Lyon",
        author: "The Davoyage team",
        facts: "At a glance",
        toc: "Contents",
        quote: "Get a quote",
        quoteShort: "Get a quote",
        call: "Call",
        bookEyebrow: "Book this trip",
        bookTitle: "Ride with a private driver",
        bookPoints: ["Pick-up at your hotel, station or airport", "Your driver waits for you at every stop", "Your luggage and purchases stay in the trunk"],
        ctaEyebrow: "Your trip",
        ctaTitle: "A ski resort, a vineyard, a flight to catch?",
        ctaText: "Tell us the date, how many you are and what you would like to see: we will send you a proposal.",
        categories: {
            vignobles: "Wine regions",
            ski: "Ski resorts",
            aeroports: "Airports and stations",
            excursions: "Day trips",
            pratique: "Practical info"
        }
    },
    ru: {
        meta: {
            title: "Блог Davoyage - Будьте в курсе последних советов и тенденций в путешествиях",
            description: "Будьте в курсе событий с блогом Davoyage, вашим источником советов, тенденций и новостей в сфере путешествий. От экспертной информации до путеводителей, мы следим за всеми новинками.",
        },
        og: {
            image: {
                url: "https://res.cloudinary.com/dgdbo8vri/dpr_auto,q_auto/v1791370742/transfert-lyon-val-d-isere-van-noir.webp",
                alt: "Mercedes Classe V Davoyage, chauffeur privé"
            }
        },
        eyebrow: "Путевые заметки",
        head: "Поездки и трансферы из Лиона",
        lead: "Виноградники, горнолыжные курорты, аэропорты: маршруты, время в пути и советы наших водителей, чтобы путешествовать, не садясь за руль.",
        photoBy: "Фото:",
        photoOn: "/",
        crumb: "Блог",
        all: "Все",
        featured: "Главное",
        latest: "Новые статьи",
        related: "Читайте также",
        allArticles: "Все статьи",
        readMore: "Читать статью",
        readTime: "мин чтения",
        fromLyon: "от Лиона",
        author: "Команда Davoyage",
        facts: "Коротко",
        toc: "Содержание",
        quote: "Запросить стоимость",
        quoteShort: "Узнать цену",
        call: "Позвонить",
        bookEyebrow: "Забронировать поездку",
        bookTitle: "Поездка с частным водителем",
        bookPoints: ["Встреча у отеля, на вокзале или в аэропорту", "Водитель ждет вас на каждой остановке", "Багаж и покупки остаются в багажнике"],
        ctaEyebrow: "Ваша поездка",
        ctaTitle: "Курорт, виноградники или рейс, на который нужно успеть?",
        ctaText: "Сообщите дату, число пассажиров и ваши пожелания, и мы пришлем предложение.",
        categories: {
            vignobles: "Винные туры",
            ski: "Горнолыжные курорты",
            aeroports: "Аэропорты и вокзалы",
            excursions: "Экскурсии",
            pratique: "Полезная информация"
        }
    }
};